import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import ESeverityLevel from "@/cms/enums/ESeverityLevel";
import TValidations from "@/cms/types/TValidations";

type TRMDRTextArea = {
    id:string;

    name: string;
    title: string|null;
    rmdrRef?: any;
    
    value: string|null;
    defaultValue: string|null;
    placeholder: string|null;
    rows: number;

    errors: TValidations[]|null;
    isDisabled: boolean;
    isAutoFocus: boolean;

    onValueChanged: (name:string, value?:string|null) => void;

    inputClassName?: string;
    className?: string;
    disabled: boolean;

}


const RMDRTextArea = ( props: TRMDRTextArea ) => {
    
    const [validation, setValidation] = useState<any>(null);

    useEffect(
        () => {
            let __value = props.errors?.find((item:any) => item.propertyName === props.name);

            if ( __value ) { 
                let className = "";
                let inputClassName = "";

                if (__value.severity === ESeverityLevel.ERROR) {
                    className = "tw-bg-red-100 tw-rounded-t-none tw-text-red-700 tw-p-2 tw-rounded tw-text-sm";
                    inputClassName = "tw-bg-red-100 tw-rounded-b-none tw-text-red-700 tw-rounded";
                }
                else if (__value.severity === ESeverityLevel.WARNING) {
                    className = "tw-bg-orange-100 tw-rounded-t-none tw-text-orange-700 tw-p-2 tw-rounded tw-text-sm";
                    inputClassName = "tw-bg-orange-100 tw-rounded-b-none tw-text-orange-700 tw-rounded";
                }
                else if (__value.severity === ESeverityLevel.INFO) {
                    className = "tw-bg-blue-100 tw-rounded-t-none tw-text-blue-700 tw-p-2 tw-rounded tw-text-sm";
                    inputClassName = "tw-bg-blue-100 tw-rounded-b-none tw-text-blue-700 tw-rounded";
                }
                
                setValidation({ ...__value, className, inputClassName }); 
            }

            if ( !__value && validation ) setValidation(null);
        }, [ props.errors ]
    )

    const valueChanged = ( event:any ) => {
        if ( validation !== null ) setValidation(null);
    }

    return (
        <div className={props.className}>
            <textarea
                id={props.id}
                ref={props.rmdrRef}
                
                name={props.name}
                placeholder={props.placeholder||""}
                disabled={props.disabled}
                onChange={valueChanged}

                rows={props.rows}

                className={clsx(props.inputClassName, validation?.inputClassName)}
            >
                {props.value}
            </textarea>
            {
                validation && <span className={clsx(validation.className, "tw-text-left")}>{ validation.errorMessage }</span>
            }
        </div>
    );
}

RMDRTextArea.defaultProps = {
    name: "RMDRTextBox",
    title: null,
    rmdrRef: undefined,
    
    value: "",
    defaultValue: "",
    placeholder: "",
    rows: 1,

    validations: [],
    isDisabled: false,
    isAutoFocus: false,

    lookupDataSource: null,

    onValueChanged: null,

    inputClassName: "form-control",
    className: undefined,
    disabled: false,
}

export default RMDRTextArea;
export type {
    TRMDRTextArea
};